import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { ResponsiveBaseComponent } from 'shared-lib';
import { ParkingOperatorDto } from '../../../../api/gen';

@Component({
  selector: 'app-parking-operator-item',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatChipsModule,
    MatMenuModule,
    MatDividerModule
  ],
  templateUrl: './parking-operator-item.component.html',
  styleUrl: './parking-operator-item.component.scss'
})
export class ParkingOperatorItemComponent extends ResponsiveBaseComponent {
  @Input() operator!: ParkingOperatorDto;
  @Output() edit = new EventEmitter<ParkingOperatorDto>();
  @Output() delete = new EventEmitter<ParkingOperatorDto>();
  @Output() viewDetails = new EventEmitter<ParkingOperatorDto>();
  @Output() assignParkingSpace = new EventEmitter<ParkingOperatorDto>();
  @Output() unassignParkingSpace = new EventEmitter<ParkingOperatorDto>();

  onEdit() {
    this.edit.emit(this.operator);
  }

  onDelete() {
    this.delete.emit(this.operator);
  }

  onViewDetails() {
    this.viewDetails.emit(this.operator);
  }

  onAssignParkingSpace() {
    this.assignParkingSpace.emit(this.operator);
  }

  onUnassignParkingSpace() {
    this.unassignParkingSpace.emit(this.operator);
  }

  getOperatorFullName(): string {
    const firstName = this.operator.firstName || '';
    const lastName = this.operator.lastName || '';
    return `${firstName} ${lastName}`.trim() || 'Unknown Operator';
  }

  getOperatorInitials(): string {
    const firstName = this.operator.firstName || '';
    const lastName = this.operator.lastName || '';
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'UO';
  }

  getParkingSpacesCount(): number {
    return this.operator.parkingSpaces?.length || 0;
  }

  getLicensesCount(): number {
    return this.operator.licenses?.length || 0;
  }

  hasAssignedParkingSpaces(): boolean {
    return (this.operator.parkingSpaces?.length || 0) > 0;
  }
}
